__turbopack_context__.v({
  "darktext": "rLBZ8G_darktext",
  "rowSwapped": "rLBZ8G_rowSwapped",
  "splitview": "rLBZ8G_splitview",
  "splitviewcode": "rLBZ8G_splitviewcode",
  "splitviewtext": "rLBZ8G_splitviewtext",
  "swapped": "rLBZ8G_swapped",
});
